
import { useQuery } from '@tanstack/react-query';
import { EventCard, CreateEventCard } from '../EventCard/EventCard';
import { getUrl } from '../../App';
import SkeletonCard from '@shared/components/SkeletonCard/SkeletonCard';
import styles from './EventListView.module.css';


const fetch_events = async () => {
  const response = await fetch(`${getUrl()}/api/events/`,{credentials: 'include', });

  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }
  return await response.json();
}

const EventListView = () => {

  const events = useQuery({
    queryKey: ['events'], queryFn: () => fetch_events(),
    staleTime: 5 * 60 * 1000, // Cache data for 5 minutes
    cacheTime: 5 * 60 * 1000,
  });

  if (events.isError) {
    return <div>Error fetching logs: {events.error.message}</div>;
  }

  if (events.isLoading) {
    return (
      <div className="view-content">
        <div className="panel-header">
          <h3>EventView</h3>
        </div>
        <div className={styles.projects_section}>
          <div className={`${styles.project_boxes} ${styles.jsGridView}`}>
            <SkeletonCard />
          </div>
        </div>
      </div >
    )
  }

  return (
    <div className={styles.view_content}>
      <div className="panel-header">
        <h3>EventView</h3>
      </div>
      <div className={styles.projects_section}>
        <div className={`${styles.project_boxes} ${styles.jsGridView}`}>

          {events.data.length > 0 ? (
            <>
              {events.data.map((event) => (
                <EventCard
                  event={event}
                  key={event.id}
                ></EventCard>
              ))}
            </>
          ) : (
            <div className={styles.emptyState}>
              No events found
            </div>
          )}
        </div>
      </div>
    </div >
  );
};

export default EventListView;